module.exports = __webpack_public_path__ + "img/NC.09a00f75.svg";